<template>
    <div style="height: 100%;width: 100%;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
            <el-tab-pane label="未分配" name="first"></el-tab-pane>
            <el-tab-pane label="已经分配" name="second"></el-tab-pane>
            <el-tab-pane label="全部" name="three"></el-tab-pane>
        </el-tabs>

        <van-search v-model="param" placeholder="请输入搜索关键词" @search="onSearch" @cancel="onSearch" @clear="onSearch"/>

        <el-table height="calc(100% - 10rem)" :data="beautyStaffs" show-header style="width: 100%;" border v-loadmore="laodMore">
            <el-table-column prop="membername" align="center" label="姓名"></el-table-column>
            <el-table-column prop="accoundate" align="center" label="最近到店"></el-table-column>
            <el-table-column prop="staffname" align="center" label="负责人">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.staffids" placeholder="请选择" multiple size="mini" @change="setCardManager(scope)">
                        <el-option v-for="item in staffs" :key="item.staffid" :label="item.staffname" :value="item.staffid"></el-option>
                    </el-select>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                param:"",
                activeName:"first",
                storeid:localStorage.getItem("storeid"),
                beautyStaffs:[],
                curpage:1,
                isFinite:false,
                staffs:[],
                type:1,
            }
        },
        created: function () {
            this.getAllCardInfoDdInfo();
            this.getStaffByDeptId();
        },
        methods: {
            onSearch(){
                this.curpage=1;
                this.beautyStaffs=[];
                this.getAllCardInfoDdInfo();
            },
            setCardManager(scope){
                let headstaff=new Object();
                headstaff.storeid=this.storeid;
                headstaff.cardid=scope.row.cardid;
                headstaff.staffid=scope.row.staffid;
                headstaff.createtor=localStorage.getItem("staffid");
                headstaff.createtorname=localStorage.getItem("staffname");
                headstaff.staffids=scope.row.staffids;
                this.$postw("cardmanager/setCardManager",headstaff).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleClick(name){
                if(this.activeName=="first"){
                    this.beautyStaffs=[];
                    this.curpage=1;
                    this.type=1;
                    this.isFinite=false;
                    this.getAllCardInfoDdInfo();
                }
                else if(this.activeName=="second"){
                    this.beautyStaffs=[];
                    this.curpage=1;
                    this.type=2;
                    this.isFinite=false;
                    this.getAllCardInfoDdInfo();
                }
                else{
                    this.beautyStaffs=[];
                    this.curpage=1;
                    this.type=0;
                    this.isFinite=false;
                    this.getAllCardInfoDdInfo();
                }
            },
            getStaffByDeptId(){
                this.$post("staff/getStaffByDeptId",{storeid:this.storeid,deptid:"32"}).then(res=>{
                    if(res.sucess){
                        this.staffs=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            laodMore(){
                if(this.isFinite==false){
                    this.curpage++;
                    this.getAllCardInfoDdInfo();
                }
                else{
                    this.$message({
                        message: '已经全部加载完成',
                        type: 'warning'
                    });
                }
            },
            getAllCardInfoDdInfo(){
                this.$post("beautymanager/getAllCardInfoDdInfo",{storeid:this.storeid,curpage:this.curpage,type:this.type,param:this.param}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null && obj.length>0){
                            for(let val of obj){
                                this.beautyStaffs.push(val);
                            }
                        }
                        else{
                            this.isFinite=true;
                        }
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/beauty/sendcard.vue